import { useDb } from '../../core/db.js';
import { useUser } from '../../user/composables/user.js';
import ConfigEditor from './ConfigEditor.js';

export default {
  props: {},
  setup() {
    return {
      user: useUser(),
      db: useDb(),
    };
  },
  components: {
    ConfigEditor,
  },
  mounted() {
    this.modal = new bootstrap.Modal(this.$refs.modal);
    this.$el.addEventListener('hidden.bs.modal', event => {
      this.closePopup();
    });
    if (this.show) {
      this.modal.show();
    }
  },
  unmounted() {
    this.modal?.hide();
  },
  watch: {
    show() {
      if (!this.modal) {
        return;
      }
      if (this.show) {
        this.modal.show();
      } else {
        this.modal.hide();
      }
    },
    configs() {
      if (!this.configs.some(config => config.name === this.active)) {
        this.active = this.configs[0]?.name ?? '';
      }
    },
  },
  data() {
    return {
      active: '_config',
    };
  },
  computed: {
    configs() {
      return this.db.configs.filter(
        config =>
          !config.schema.editableBy ||
          this.user.hasAnyRole(config.schema.editableBy)
      );
    },
  },
  methods: {
    closePopup() {
      this.modal.hide();
      this.$emit('close-popup');
    },
  },
  template: /*html*/ `
  <button class="btn btn-secondary" @click="modal.show()"><i class="bi bi-gear"></i></button>
  <div class="modal" ref="modal">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Settings</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body d-flex flex-column gap-2">
          <ul class="nav nav-tabs">
            <li class="nav-item" v-for="config in configs">
              <button class="nav-link" :class="{'active': active === config.name}" @click="active = config.name">{{ config.schema.title ?? config.name }}</button>
            </li>
          </ul>
          <template v-for="config in configs">
            <ConfigEditor :configName="config.name" v-if="config.name === active" :defaults="{displayMode: 'grid-horizontal'}" :mode="config.replicationHandler ? 'form' : 'edit'"></ConfigEditor>
          </template>
        </div>
      </div>
    </div>
  </div>
`,
};
